import { render, staticRenderFns } from "./bottomHeader.vue?vue&type=template&id=12960b6e&scoped=true"
import script from "./bottomHeader.vue?vue&type=script&lang=js"
export * from "./bottomHeader.vue?vue&type=script&lang=js"
import style0 from "./bottomHeader.vue?vue&type=style&index=0&id=12960b6e&prod&lang=scss&scoped=true"
import style1 from "./bottomHeader.vue?vue&type=style&index=1&id=12960b6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12960b6e",
  null
  
)

export default component.exports